module.exports = __webpack_public_path__ + "images/f094747f6d86753b5c27212b117169e1.svg";